import { rotuloDoStatus, StatusDaFase } from '../minha-equipe-calculos';

// Texto por cor de fundo (design): navy no rosa e no verde, azul-escuro no amarelo.
// SPEC_DEVIATION: a pílula neutra usa `content` (o `text-soft` do design dá 4,1:1 no `surface-200`).
const TEXTO_POR_FUNDO: Record<string, string> = {
  'bg-brand-pink-light': 'text-brand-navy',
  'bg-brand-green': 'text-brand-navy',
  'bg-brand-yellow': 'text-brand-blue-dark',
  'bg-surface-200': 'text-content',
};

interface PilulaDeStatusProps {
  /** null = sem status conhecido: pílula neutra com `rotuloSemStatus`. */
  status: StatusDaFase | null;
  rotuloSemStatus: string;
  /** Tamanho e espaçamento de cada lugar (lista ou painel). */
  className: string;
}

/** Pílula do status da realização, com os rótulos e as cores de `rotuloDoStatus`. */
export default function PilulaDeStatus({ status, rotuloSemStatus, className }: PilulaDeStatusProps) {
  const { rotulo, cor } = status ? rotuloDoStatus(status) : { rotulo: rotuloSemStatus, cor: 'bg-surface-200' };

  return (
    <span
      className={`whitespace-nowrap rounded-jj-pill font-bold uppercase tracking-[0.04em] ${cor} ${TEXTO_POR_FUNDO[cor]} ${className}`}
    >
      {rotulo}
    </span>
  );
}
